(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.rs-product[data-product-card]').forEach((card) => {
      if (card.dataset.ready) return;
      const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
      const select = card.querySelector('[name="id"]');
      const submit = card.querySelector('[data-submit]');
      const price = card.querySelector('[data-price]');
      const status = card.querySelector('[data-status]');
      const image = card.querySelector('[data-product-image]');
      const form = card.querySelector('form');
      const detail = card.querySelector('[data-product-detail]');
      const detailUrl = detail.href;
      const cartLink = card.querySelector('[data-cart-link]');
      let pending = false;
      let uncertain = false;
      if (!variants.length || !select || !submit) return;
      const colors = [...new Set(variants.map((v) => v.options[0]))];
      const sizes = [...new Set(variants.map((v) => v.options[1]))];
      let color = colors[0];
      let size = '';
      const options = card.querySelector('[data-options]');
      const buttonGroups = [];
      [colors, sizes].forEach((values, group) => {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = group === 0 ? 'カラー' : 'サイズ';
        const selected = document.createElement('span');
        legend.append(selected);
        fieldset.append(legend);
        const row = document.createElement('div');
        row.className = 'rs-option-row';
        values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rs-option';
          button.dataset.value = value;
          button.setAttribute('aria-pressed', 'false');
          if (group === 0) {
            button.dataset.color = value;
            const swatch = document.createElement('span');
            swatch.className = 'rs-swatch'; swatch.dataset.color = value;
            swatch.setAttribute('aria-hidden', 'true');
            button.append(swatch);
          }
          button.append(document.createTextNode(value));
          button.addEventListener('click', () => {
            if (pending) return;
            if (group === 0) color = value; else size = value;
            update();
          });
          row.append(button);
        });
        fieldset.append(row); options.append(fieldset);
        buttonGroups.push({ selected, buttons: [...row.children] });
      });
      function update() {
        const variant = variants.find((v) => v.options[0] === color && v.options[1] === size);
        select.value = variant ? String(variant.id) : '';
        buttonGroups.forEach((group, index) => {
          const value = index === 0 ? color : size;
          group.selected.textContent = value || '選択してください';
          group.buttons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.value === value));
            if (index === 1) {
              const v = variants.find((v) => v.options[0] === color && v.options[1] === button.dataset.value);
              button.dataset.soldOut = String(!v?.available);
              button.setAttribute('aria-label', `${button.dataset.value}${v?.available ? '' : '（在庫なし）'}`);
            }
          });
        });
        const display = variant || variants.find((v) => v.options[0] === color);
        if (display) price.textContent = display.priceLabel;
        const imageUrl = color === 'ネイビー' ? card.dataset.navyImage : card.dataset.blackImage;
        if (imageUrl) { image.src = imageUrl; image.alt = `${card.dataset.productTitle} ${color}`; }
        const url = new URL(detailUrl);
        if (variant) url.searchParams.set('variant', variant.id);
        detail.href = url.href;
        submit.disabled = pending || uncertain || !variant?.available;
        submit.textContent = pending ? '追加しています…' : uncertain ? 'カートをご確認ください' : !size ? 'サイズを選択してください' : variant?.available ? 'カートに追加する' : 'この組み合わせは在庫がありません';
        status.textContent = uncertain ? '追加結果を確認できませんでした。再度追加する前に、カートをご確認ください。' : !size ? 'カラーとサイズを選んでください。' : variant?.available ? `${color} / ${size} を1点カートに追加します。` : `${color} / ${size} は在庫がありません。別の組み合わせをご確認ください。`;
      }
      const initial = variants.find((v) => String(v.id) === select.value);
      if (initial) { color = initial.options[0]; size = initial.options[1]; }
      options.hidden = false;
      card.querySelector('[data-native]').hidden = true;
      select.required = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const variant = variants.find((v) => String(v.id) === select.value);
        if (pending || uncertain || !variant?.available) return;
        const endpoint = new URL(form.action);
        if (form.dataset.preview === 'true' || endpoint.origin !== window.location.origin) {
          status.textContent = 'プレビューではカート追加できません。商品詳細からご確認ください。';
          return;
        }
        endpoint.pathname += '.js';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        pending = true;
        form.setAttribute('aria-busy', 'true');
        buttonGroups.forEach((group) => group.buttons.forEach((button) => { button.disabled = true; }));
        update();
        status.textContent = `${color} / ${size} を追加しています。`;
        try {
          const response = await fetch(endpoint.href, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
            signal: controller.signal,
          });
          const data = await response.json();
          if (!response.ok) {
            // A rejected request can still leave cart state uncertain; never retry automatically.
            if (response.status >= 500) throw new Error('Uncertain cart state');
            status.textContent = typeof data.description === 'string' ? data.description : '追加できませんでした。カートと商品詳細をご確認ください。';
            cartLink.hidden = false;
            return;
          }
          if (!data.items?.some((item) => String(item.id) === String(variant.id) && item.quantity > 0)) {
            throw new Error('Unexpected cart response');
          }
          status.textContent = `${color} / ${size} を1点カートに追加しました。`;
          cartLink.hidden = false;
        } catch {
          uncertain = true;
          status.textContent = '追加結果を確認できませんでした。再度追加する前に、カートをご確認ください。';
          cartLink.hidden = false;
        } finally {
          clearTimeout(timeout);
          pending = false;
          form.removeAttribute('aria-busy');
          buttonGroups.forEach((group) => group.buttons.forEach((button) => { button.disabled = false; }));
          submit.disabled = uncertain || !variant.available;
          submit.textContent = uncertain ? 'カートをご確認ください' : 'カートに追加する';
        }
      });
      card.dataset.ready = 'true';
      update();
    });
    scope.querySelectorAll('.rs').forEach((root) => {
      if (root.dataset.stickyReady) return;
      const sticky = root.querySelector('.rs-sticky');
      const hero = root.querySelector('.rs-hero');
      const shop = root.querySelector('.rs-products');
      if (!sticky || !hero || !shop) return;
      const updateSticky = () => {
        const heroRect = hero.getBoundingClientRect();
        const shopRect = shop.getBoundingClientRect();
        sticky.classList.toggle('is-visible', heroRect.bottom < 0 && !(shopRect.top < innerHeight - 70 && shopRect.bottom > 0));
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      root.dataset.stickyReady = 'true';
      updateSticky();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
